import styled from 'styled-components';
import { blurBox, timeDescription } from 'styles/parcelSharedStyles';
import iconLocationSVG from 'icons/location.svg';
import iconHandPackageSVG from 'icons/hand-package.svg';
import CustomScrollbar from 'components/CustomScrollbar';
import { ReactSVG } from 'react-svg';
import { PickUpLocation } from '../PickUpLocation';

export const MainBox = styled(CustomScrollbar)`
  ${blurBox};
  position: relative;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
`;

export const Description = styled.div`
  ${timeDescription}
`;

export const Location = styled.div<{ isClickable: boolean }>`
  margin-top: 8px;
  display: flex;
  align-items: center;
  font-size: ${({ theme }) => theme.configs.fonts.fontSize.additionalDetails}px;
  cursor: ${({ isClickable }) => (isClickable ? 'pointer' : 'auto')};
  background: none;
  border: none;
  padding: 0;
  width: fit-content;
  font-family: inherit;
`;

export const City = styled.div`
  margin-left: 8px;
`;

export const reactModalStyle = {
  content: {
    padding: 0,
    top: '45%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    transform: 'translate(-50%, -50%)',
  },
  overlay: {
    position: 'absolute',
  },
};

export const LocationIcon = styled(ReactSVG).attrs((props) => {
  return {
    src: iconLocationSVG,
    ...props,
  };
})`
  fill: currentColor;
`;

export const CustomLocationIcon = styled.img`
  widht: 24px;
  height: 24px;
`;

export const RecipientContainer = styled.div`
  margin-top: 8px;
  display: flex;
  align-items: center;
  font-size: ${({ theme }) => theme.configs.fonts.fontSize.additionalDetails}px;
`;

export const RecipientName = styled.div`
  margin-left: 8px;
`;

export const RecipientIcon = styled(ReactSVG).attrs((props) => {
  return {
    src: iconHandPackageSVG,
    ...props,
  };
})`
  fill: currentColor;
`;

export const CustomRecipientIcon = styled.img`
  width: 24px;
  height: 24px;
`;

export const StyledPickUpLocation = styled(PickUpLocation)`
  margin-top: 8px;
`;

export const HardCodedForMeccaLine = styled.div`
  margin-top: 5px;
`;

export const HardCodedForMeccaContainer = styled.div`
  margin-top: 10px;
`;

export const CarrierRedirectContainer = styled.div`
  margin-top: auto;
`;
